import type { BlockCMS, Product } from '@/types'
import Link from 'next/link'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'
import CarrouselArrowIconMiddle from '../Icon/CarrouselArrowIconMiddle'
import ImageOptimize from '../ImageOptimize'
interface ModuleSliderType {
  data: BlockCMS
  order: number
}
const ModuleSlider = ({ data, order }: ModuleSliderType) => {
  const settings: Settings = {
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 5000,
    // adaptiveHeight: true,
    slidesToShow: 1,
    variableWidth: false,
    nextArrow: <CarrouselArrowIconMiddle type='next' />,
    prevArrow: <CarrouselArrowIconMiddle type='prev' />,
  }
  const settingsNonSlider: Settings = {
    swipe: false,
    slidesToShow: 1,
    infinite: false,
    variableWidth: false,
    draggable: false,
    arrows: false,
    // adaptiveHeight: true,
  }

  return (
    <section
      id={data._id}
      className={`${data?.type} ${data?.hideBot ? '' : 'pb-[20px]'} ${
        'order-[' + (order + 1) + ']'
      } scroll-mt-[158px]`}
    >
      <div className='sliderCMS'>
        {data?.data?.length > 1 ? (
          <Slider {...settings} className='max-w-screen flex'>
            {data &&
              data?.data.map((slide: Product, index: number) => (
                <Link
                  href={slide.path ? slide.path : '/'}
                  className='block'
                  key={index}
                >
                  {slide.image ? (
                    <ImageOptimize
                      src={slide.image}
                      alt=''
                      width='0'
                      height='0'
                      sizes='100%'
                      className='h-auto w-full'
                    />
                  ) : (
                    ''
                  )}
                </Link>
              ))}
          </Slider>
        ) : (
          <Slider
            {...settingsNonSlider}
            className='max-w-screen non-slick ml-0 mr-auto flex'
          >
            {data &&
              data?.data.map((slide: Product, index: number) => (
                <Link
                  href={slide.path ? slide.path : '/'}
                  className='block'
                  key={index}
                >
                  {slide.image ? (
                    <ImageOptimize
                      src={slide.image}
                      alt=''
                      width='0'
                      height='0'
                      sizes='100%'
                      className='h-auto w-full'
                    />
                  ) : (
                    ''
                  )}
                </Link>
              ))}
          </Slider>
        )}
      </div>
    </section>
  )
}

export default ModuleSlider
